import { ItemCollection } from "../dto/item/ItemCollection";
export default class PurchaseEvent {
    constructor() {
        this.currency = 'EUR';
        this.movexTransactionId = '';
        this.shipping = '';
        this.transactionId = '';
        this.value = '';
        this.itemCollection = new ItemCollection();
    }
    export() {
        return {
            currency: this.currency,
            movex_transaction_id: this.movexTransactionId,
            shipping: this.shipping,
            transaction_id: this.transactionId,
            value: this.value,
            items: this.itemCollection.export(),
        };
    }
}
